var map = {
	"./Hanes/back.webp": "0366c",
	"./Hanes/chest.webp": "2c0d",
	"./Hanes/front.webp": "6e16",
	"./Hanes/logo.webp": "96ee",
	"./Hanes/material.webp": "27ce",
	"./Hanes/side.webp": "23ce",
	"./Hanes/stain.webp": "056c",
	"./Hanes/thickness.webp": "0266",
	"./Hanes/wrinkles.webp": "34c4",
	"./UNIQLO/back.webp": "d01e",
	"./UNIQLO/chest.webp": "6d0d",
	"./UNIQLO/front.webp": "6504",
	"./UNIQLO/logo.svg": "13e8",
	"./UNIQLO/material.webp": "275f",
	"./UNIQLO/side.webp": "d7d6",
	"./UNIQLO/stain.webp": "e945",
	"./UNIQLO/thickness.webp": "9686",
	"./UNIQLO/wrinkles.webp": "07d1",
	"./chevron_left_black_24dp.svg": "9f22",
	"./chevron_right_black_24dp.svg": "1bfa",
	"./logo-yoko.svg": "241b",
	"./logo.svg": "9b19",
	"./muji/back.webp": "0322",
	"./muji/chest.webp": "4574",
	"./muji/front.webp": "2e99",
	"./muji/logo.webp": "ad74",
	"./muji/material.webp": "488a",
	"./muji/side.webp": "dad4",
	"./muji/stain.webp": "6d81",
	"./muji/thickness.webp": "049d",
	"./muji/wrinkles.webp": "19e3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";